import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, FlaskConical, Flame } from 'lucide-react';
const ingredients = [{
  icon: Leaf,
  name: 'Sägepalmenextrakt (Serenoa repens)',
  dose: '640 mg',
  func: 'Hemmt 5-Alpha-Reduktase, unterstützt normales Prostatavolumen'
}, {
  icon: Leaf,
  name: 'Pygeum Africanum',
  dose: '100 mg',
  func: 'Reduziert Entzündungsmarker, fördert Harnfluss'
}, {
  icon: Leaf,
  name: 'Brennnesselblatt (Urtica dioica)',
  dose: '360 mg',
  func: 'Unterstützt Blasenentleerung, wirkt entzündungshemmend'
}, {
  icon: FlaskConical,
  name: 'Beta-Sitosterol',
  dose: '180 mg',
  func: 'Pflanzliches Sterol, verbessert Harnstrahlstärke'
}, {
  icon: FlaskConical,
  name: 'Lycopin',
  dose: '10 mg',
  func: 'Antioxidativer Zellschutz für Prostatagewebe'
}, {
  icon: Flame,
  name: 'BioPerine® (Piper Nigrum)',
  dose: '5 mg',
  func: 'Erhöht Bioverfügbarkeit aller Wirkstoffe um bis zu 30%'
}];
export function IngredientsSection() {
  return <section className="py-28 md:py-32 bg-slate-50 text-slate-900 relative overflow-hidden" data-id="element-161">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-162">
        <div className="text-center mb-20" data-id="element-163">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-slate-900 mb-6" data-id="element-164">
            Jeder Wirkstoff. Jede Dosierung. Transparent.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-165">
          {ingredients.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-white p-8 rounded-2xl border border-slate-200 hover:border-brand-300 hover:shadow-md transition-all duration-300 flex items-start gap-6" data-id="element-166">
              <div className="w-14 h-14 rounded-xl bg-slate-50 flex items-center justify-center flex-shrink-0 group-hover:bg-brand-50 transition-colors" data-id="element-167">
                <item.icon className="w-7 h-7 text-brand-500" strokeWidth={1.5} data-id="element-168" />
              </div>

              <div className="flex-1" data-id="element-169">
                <h3 className="text-xl font-bold text-slate-900 mb-1" data-id="element-170">
                  {item.name}
                </h3>
                <div className="text-2xl font-serif font-bold text-brand-500 mb-3" data-id="element-171">
                  {item.dose}
                </div>
                <p className="text-slate-500 text-base leading-relaxed group-hover:text-slate-600 transition-colors" data-id="element-172">
                  {item.func}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}